import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizationGuardService } from '@egym/ngx-adm-int';
import { EmptyRouteComponent } from './components/empty-route/empty-route.component';
import { GymfinderComponent } from './pages/gymfinder/gymfinder.component';
import { SearchFiltersComponent } from './pages/search-filters/search-filters.component';
import { GymComponent } from './pages/gym/gym.component';
import { ChangelogComponent } from './pages/changelog/changelog.component';
import { ProfileCompletenessComponent } from './pages/profile-completeness/profile-completeness.component';

const routes: Routes = [
  {
    path: 'gym-location',
    data: {
      breadcrumb: 'Gym Location',
    },
    children: [
      {
        path: 'gymfinder',
        data: {
          breadcrumb: 'Gym Finder',
        },
        children: [
          {
            path: '',
            component: GymfinderComponent,
            canActivate: [AuthorizationGuardService],
            data: {
              permissions: ['viewGymfinderGym'],
            },
          },
          {
            path: 'gym/:id',
            canActivate: [AuthorizationGuardService],
            data: {
              permissions: ['viewGymfinderGym'],
              breadcrumb: 'Gym',
            },
            children: [
              {
                path: '**',
                component: GymComponent,
                canActivate: [AuthorizationGuardService],
                data: {
                  permissions: ['viewGymfinderGym'],
                  breadcrumb: 'internal',
                },
              },
            ],
          },
          {
            path: 'search-filters',
            component: SearchFiltersComponent,
            canActivate: [AuthorizationGuardService],
            data: {
              permissions: ['editSearchFilters'],
              breadcrumb: 'Search Filters',
            },
          },
        ],
      },
      {
        path: 'change-log',
        data: {
          breadcrumb: 'Change Log',
        },
        children: [
          {
            path: '',
            component: ChangelogComponent,
            canActivate: [AuthorizationGuardService],
            data: {
              permissions: ['viewGymfinderGym'],
            },
          },
        ],
      },
      {
        path: 'profile-completeness',
        data: {
          breadcrumb: 'Gym Profile Completeness',
        },
        children: [
          {
            path: '',
            component: ProfileCompletenessComponent,
            canActivate: [AuthorizationGuardService],
            data: {
              permissions: ['viewGymfinderGym'],
            },
          },
        ],
      },
      { path: '**', component: EmptyRouteComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
